import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import CadastroAuxiliarPage, { CadastroAuxiliarPageProps } from '../../components/CadastroAuxiliarPage';

// Configuração de cada cadastro auxiliar, indexada pelo slug usado na URL.
const CADASTROS: Record<string, CadastroAuxiliarPageProps> = {
  'tipo-empresa': {
    tipo: 'tipo_empresa',
    titulo: 'Tipo da Empresa',
    descricao: 'Define os tipos possíveis de empresa (ex.: Grupo, Empresa Fim, Filial) e sua posição na hierarquia de criação.',
    fieldLabel: 'Tipo da Empresa',
    placeholder: 'Ex. Grupo, Empresa, Filial ...',
    listTitle: 'Tipo da Empresa',
    listEmptyText: 'Aqui lista todos os tipos de empresas cadastrados no sistema.',
    isGlobal: true,
    showNivel: true,
  },
  'ramo-atuacao': {
    tipo: 'ramo_atuacao',
    titulo: 'Ramo de Atuação',
    descricao: 'Gerencie os ramos de atuação disponíveis para o cadastro de empresas.',
    fieldLabel: 'Ramo de Atuação',
    placeholder: 'Ex. Tecnologia, Saúde, Financeiro ...',
    listTitle: 'Ramos de Atuação',
    listEmptyText: 'Aqui lista todos os ramos de atuação cadastrados no sistema.',
    isGlobal: true,
  },
  'regulamentacao-setorial': {
    tipo: 'regulamentacao_setorial',
    titulo: 'Regulamentação Setorial',
    descricao: 'Gerencie os reguladores setoriais disponíveis para o cadastro de empresas.',
    fieldLabel: 'Regulador',
    placeholder: 'Ex. ANS, Susep, Bacen ...',
    listTitle: 'Reguladores Cadastrados',
    listEmptyText: 'Aqui lista todos os Reguladores cadastrados no sistema.',
    isGlobal: true,
    showDocumento: true,
  },
  'tipo-endereco': {
    tipo: 'tipo_endereco',
    titulo: 'Tipo do Endereço',
    descricao: 'Gerencie os tipos de endereço cadastrados no sistema.',
    fieldLabel: 'Tipos de endereços',
    placeholder: 'Ex. Comercial, Cobrança, Correspondência ...',
    listTitle: 'Tipos de Endereços',
    listEmptyText: 'Aqui lista todos os tipos de endereços já cadastrados no sistema.',
  },
  'diretorias': {
    tipo: 'diretoria',
    titulo: 'Diretorias',
    descricao: 'Gerencie as diretorias cadastradas no sistema.',
    fieldLabel: 'Diretoria',
    placeholder: 'Ex: Diretoria de Operações',
    listTitle: 'Diretorias',
    listEmptyText: 'Aqui lista todas as diretorias cadastradas no sistema.',
  },
  'gerencias': {
    tipo: 'gerencia',
    titulo: 'Gerências',
    descricao: 'Gerencie as gerências cadastradas no sistema.',
    fieldLabel: 'Gerência',
    placeholder: 'Ex: Gerência de Suporte',
    listTitle: 'Gerências',
    listEmptyText: 'Aqui lista todas as gerências cadastradas no sistema.',
  },
  'departamentos': {
    tipo: 'departamento',
    titulo: 'Departamentos',
    descricao: 'Gerencie os departamentos cadastrados no sistema.',
    fieldLabel: 'Departamento',
    placeholder: 'Ex: Recursos Humanos',
    listTitle: 'Departamentos',
    listEmptyText: 'Aqui lista todos os departamentos já cadastrados no sistema.',
  },
  'tipo-pessoa': {
    tipo: 'tipo_pessoa',
    titulo: 'Tipo de Pessoa',
    descricao: 'Gerencie os tipos de pessoa cadastrados no sistema.',
    fieldLabel: 'Tipo',
    placeholder: 'Ex. Empregado, Terceiro',
    listTitle: 'Tipos de Pessoas Cadastradas',
    listEmptyText: 'Aqui lista os tipos de pessoas já cadastradas no sistema.',
  },
  'tipo-usuario': {
    tipo: 'tipo_usuario',
    titulo: 'Tipo do Usuário',
    descricao: 'Gerencie os tipos de usuário disponíveis para o cadastro de usuários.',
    fieldLabel: 'Tipo',
    placeholder: 'Ex. Administrador, DPO, Usuário',
    listTitle: 'Tipos de Usuário Cadastrados',
    listEmptyText: 'Aqui lista os tipos de usuário já cadastrados no sistema.',
  },
  'escopo-questionario': {
    tipo: 'escopo_questionario',
    titulo: 'Escopo de Questionário',
    descricao: 'Gerencie os escopos de questionário cadastrados no sistema.',
    fieldLabel: 'Escopo de Questionários',
    placeholder: 'Ex. Assessment Framework Toyota',
    listTitle: 'Escopo de Questionários',
    listEmptyText: 'Aqui lista todos os escopos de questionários cadastrados no sistema.',
  },
  'classificacao-conformidade': {
    tipo: 'classificacao_conformidade',
    titulo: 'Classificação de Conformidade',
    descricao: 'Gerencie as classificações de não conformidade usadas na Auditoria de questionários.',
    fieldLabel: 'Classificação',
    placeholder: 'Ex. Conforme, Não conformidade maior ...',
    listTitle: 'Classificações de Conformidade',
    listEmptyText: 'Aqui lista todas as classificações de conformidade cadastradas no sistema.',
    isGlobal: true,
    showItemDescricao: true,
  },
};

const CadastrosAuxiliaresPage: React.FC = () => {
  const { slug } = useParams<{ slug?: string }>();
  const config = slug ? CADASTROS[slug] : undefined;

  if (!config) {
    return <Navigate to="/app/cadastros-auxiliares/tipo-empresa" replace />;
  }

  return (
    <Container fluid className="py-3 py-md-4">
      <p className="text-muted small mb-3">Cadastros auxiliares</p>
      <CadastroAuxiliarPage {...config} />
    </Container>
  );
};

export default CadastrosAuxiliaresPage;
